import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ISpaceCapacity } from '@api/types'

const updateSpacezQuery = gql`
  mutation UpdateSpacez($input: UpdateSpacezMutationInput!) {
    updateSpacez(input: $input) {
      spaces {
        id
        code
      }
    }
  }
`

export function updateSpacez(spaces: any) {
  return client.gql
    .mutate({
      mutation: updateSpacezQuery,
      variables: { input: { spaces: spaces } },
    })
    .then((data: any) => data)
}
